module.exports = __webpack_public_path__ + "static/media/cq_cerca_blu.8ec09cca.svg";